module.exports = __webpack_public_path__ + "img/ltkfit-1x.4ff5357.jpg";